var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadButtonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70711 9.20711C4.31658 9.59763 3.68342 9.59763 3.29289 9.20711L0.292893 6.20711C-0.0976311 5.81658 -0.0976311 5.18342 0.292893 4.79289C0.683417 4.40237 1.31658 4.40237 1.70711 4.79289L3 6.08579V1.5C3 0.947715 3.44772 0.5 4 0.5C4.55228 0.5 5 0.947715 5 1.5V6.08579L6.29289 4.79289C6.68342 4.40237 7.31658 4.40237 7.70711 4.79289C8.09763 5.18342 8.09763 5.81658 7.70711 6.20711L4.70711 9.20711Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49012e-08 11.5C1.49012e-08 10.9477 0.447715 10.5 1 10.5H7C7.55229 10.5 8 10.9477 8 11.5C8 12.0523 7.55229 12.5 7 12.5H1C0.447715 12.5 1.49012e-08 12.0523 1.49012e-08 11.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadButtonIcon);
export default __webpack_public_path__ + "static/media/DownloadButtonIcon.66fbd98a0217f01a186a619fce39d8ba.svg";
export { ForwardRef as ReactComponent };